import { RouteProp, useRoute } from '@react-navigation/native';

import { useValidateSuitability } from '../../../../../../../../hooks/useValidateSuitability';
import { CustomerDetailStackParamList } from '../../../../../../../../routes/types';
import { useCustomer } from '../../../../hooks/useCustomer';

export const useValidateSuitabilityInsideCustomerDetails = () => {
  const { validateSuitability, validateProfessional, validateQualified } = useValidateSuitability();
  const { params } = useRoute<RouteProp<CustomerDetailStackParamList, 'CustomerDetail'>>();

  const { customer: routeCustomer, accountNumber } = params;
  const { customerData } = useCustomer(accountNumber);
  const customer = routeCustomer ?? customerData?.data;

  const validateUserSuitabilityAvailability = (productProfile: string) => {
    const perfilClienteLower = customer?.suitabilityProfileName?.toLowerCase();
    const productProfileLower = productProfile?.toLowerCase();

    return validateSuitability(productProfileLower, perfilClienteLower);
  };

  const validateUserQualifiedAvailability = (productIsQualified: boolean) => {
    return validateQualified(
      productIsQualified,
      customer?.qualifiedInvestor,
      customer?.professionalInvestor
    );
  };

  const validateUserProfessionalAvailability = (productIsProfessional: boolean) => {
    return validateProfessional(productIsProfessional, customer?.professionalInvestor);
  };

  const unaccessibleSuitabilityText =
    'Perfil suitability do cliente é incompatível com o perfil do produto.';
  const unaccessibleQualifiedText =
    'Esse produto é direcionado somente à clientes considerados Investidores Qualificados ou Investidores Profissionais.';
  const unaccessibleProfessionalText =
    'Esse produto é direcionado somente à clientes considerados Investidores Profissionais.';

  const validateUserAvailability = (
    productProfile: string,
    productIsQualified: boolean,
    productIsProfessional: boolean
  ) => {
    const suitabilityAvailable = validateUserSuitabilityAvailability(productProfile);
    const qualifiedAvailable = validateUserQualifiedAvailability(productIsQualified);
    const professionalAvailable = validateUserProfessionalAvailability(productIsProfessional);

    if (!professionalAvailable) {
      return { available: false, message: unaccessibleProfessionalText };
    }
    if (!qualifiedAvailable) {
      return { available: false, message: unaccessibleQualifiedText };
    }
    if (!suitabilityAvailable) {
      return { available: false, message: unaccessibleSuitabilityText };
    }
    return { available: true, message: '' };
  };

  return {
    suitabilityProfileName: customer?.suitabilityProfileName,
    unaccessibleSuitabilityText,
    unaccessibleQualifiedText,
    unaccessibleProfessionalText,
    validateUserSuitabilityAvailability,
    validateUserQualifiedAvailability,
    validateUserProfessionalAvailability,
    validateUserAvailability,
  };
};
